import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'ui-components/loadhandlers/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const Login = Loadable(lazy(() => import('views/public/login')));
const Signup = Loadable(lazy(() => import('views/public/signup')));
const InfluencerLogin = Loadable(lazy(() => import('views/public/login-influencer')));
const InfluencerSignup = Loadable(lazy(() => import('views/public/signup-influencer')));
const ForgotPassword = Loadable(lazy(() => import('views/public/forgot-password')));
const ResetPassword = Loadable(lazy(() => import('views/public/reset-password')));
const RequireLogin = Loadable(lazy(() => import('views/require-login/RequireLogin')));
const NotFound = Loadable(lazy(() => import('views/not-found/NotFound')));

const CreatorSignup = Loadable(lazy(() => import('views/public/signup-creator')));
const CreatorLogin = Loadable(lazy(() => import('views/public/login-creator')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <Navigate to="/login" />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/influencer/login',
      element: <InfluencerLogin />
    },
    {
      path: '/influencer/signup',
      element: <InfluencerSignup />
    },
    {
      path: '/creator/login',
      element: <CreatorLogin />
    },
    {
      path: '/creator/signup',
      element: <CreatorSignup />
    },
    {
      path: '/signup',
      element: <Signup />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/reset-password',
      element: <ResetPassword />
    },
    {
      path: '403',
      element: <RequireLogin />
    },
    {
      path: '*',
      element: <NotFound />
    }
  ]
};

export default AuthenticationRoutes;
